import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgFlash = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m7.601 12.413 3.703-9.036a.575.575 0 0 1 .54-.377h4.965c.397 0 .675.393.543.767L15.156 8.92a.575.575 0 0 0 .543.767h4.687c.495 0 .759.583.433.954l-8.9 10.16c-.402.458-1.146.06-.99-.527l1.697-6.364a.575.575 0 0 0-.556-.723H8.141a.575.575 0 0 1-.54-.774M5.123 20.983l1.264-3.158h-3.35l1.35-3.141"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgFlash);
export default ForwardRef;
